document.querySelectorAll(".header__inline-menu details").forEach((item) => {
  const summary = item.querySelector("summary");
  const panel = item.querySelector(".mega-menu__content");
  let closeTimer;
  item.addEventListener("mouseenter", () => {
    clearTimeout(closeTimer);
    const wasOpen = item.hasAttribute("open");
    item.setAttribute("open", true);
    if (summary) summary.setAttribute("aria-expanded", "true");
    if (!wasOpen && panel && window.matchMedia("(min-width: 990px)").matches) {
      panel.animate(
        [
          { opacity: 0, transform: "translateY(-1.5rem)" },
          { opacity: 1, transform: "translateY(0)" }
        ],
        { duration: 250, easing: "ease" }
      );
    }
  });
  item.addEventListener("mouseleave", () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      item.removeAttribute("open");
      if (summary) summary.setAttribute("aria-expanded", "false");
    }, 250);
  });
});
